<template>
  <div>
    <my-dialog :title="$tc(`generics.${type}`, 2)" v-model="openModal" :persistent="false">
      <template v-slot:content v-if="!links.length">
        <v-row>
          <v-col class="center-all">{{ $t("generics.notFound") }}
            {{ $tc(`generics.${type}`, 2) }}</v-col>
        </v-row>
      </template>
      <template v-slot:content v-else-if="type === 'verse'">
        <v-row v-for="link in links" :key="link._id">
          <v-col class="d-flex justify-start align-center">
            {{ link.source }}:
            {{ link.text }}
          </v-col>
        </v-row>
      </template>
      <template v-slot:content v-else>
        <v-row v-for="link in links" :key="link._id">
          <v-col cols="12" class="d-flex justify-start align-center">
            <h3 class="pl-4 blue-text" v-if="link.isLink">
              <a :href="link.link" v-text="link.title" target="_blank"/>
            </h3>
            <v-img v-else-if="type === 'media'" :src="link.link"  @click="openLink(link.link)" >
            </v-img>
            <iframe v-else id="player" type="text/html" width="640" height="390" :src="link.link" frameborder="0"/>
          </v-col>
        </v-row>
      </template>
      <template v-slot:actions> </template>
    </my-dialog>
  </div>
</template>
<script>
import MyDialog from "@/components/generics/MyDialog"
export default {
  name: "links-handler",
  components: { MyDialog },
  props: {
    value: Boolean,
    links: { type: Array, default: () => [] },
    type: { type: String, default: "" },
  },
  data() {
    return {}
  },
  computed: {
    openModal: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit("input", val)
      },
    },
  },
  methods: {
    openLink(link){
      const a = document.createElement("a")
      a.setAttribute("href", link)
      a.setAttribute("target", '_blank')
      a.click()
    }
  },
  mounted() { },
}
</script>
